import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { AuthenticationService } from '@pdiplatform/authentication';

const TOKEN_STORAGE_KEY: string = 'epr_token';

@Injectable()
export class AuthService {

  private _token;
  ssoAuthService:any;
  static ssoAuthenticationUrl:string = "";

  constructor(
    private injector: Injector
  ) {}

  get token() {
    let token = this._token || JSON.parse(localStorage.getItem(TOKEN_STORAGE_KEY));
     if (token && moment().isAfter(token.expiry)) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      token = null;
     }
    return token;
  }

  set token(token) {
      let isValid = token && moment().isBefore(token.expiry);
      if (isValid) {
      this._token = token;
      localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(token));
    } else {
      this._token = null;
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  }

  login(username: string, password: string, company: string): Promise<any> {
    return this.injector.get(DataService).getToken(username, password, company).then(token => {
      this.token = token;
      return !!token;
    });
  }

  loginSSO(company: string, ssoToken: string): Promise<any> {
    return this.injector.get(DataService).getTokenSSO(company, ssoToken).then(token => {
      this.token = token;
      return !!token;
    });
  }

  InitializeAuthService() {
    if(!AuthService.ssoAuthenticationUrl || !this.ssoAuthService) {
      this.injector.get(DataService).getSSOBaseUrl().then(res => {
          AuthService.ssoAuthenticationUrl = 'https://' + res.ssoBaseUrl + '/';
          this.ssoAuthService = new AuthenticationService(AuthService.ssoAuthenticationUrl);
        }, (err => {
            console.log("Unable to fetch Authentication URL. No API Connection.");
      }));
    }
  }

  logout() {
    this.token = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts